export function findTerm(term) {
  return new Promise((resolve, reject) => {
    import('./index.js')
      .then(({ default: terms }) => {
        const found = Object.entries(terms).find(([key, value]) => {
          const upperCaseTerm = term.toUpperCase()

          if (key.toUpperCase() === upperCaseTerm) return true
          else if (value.alias) {
            return value.alias.map(v => v.toUpperCase()).includes(upperCaseTerm)
          }
          return false
        })

        return resolve(found && found[1] ? found[1] : null)
      })
      .catch(reject)
  })
}
